enum RestaurantStatusEnum {
    NESSUNO ='NESSUNO',
    ASPORTO = 'ASPORTO',
    DELIVERY= 'DELIVERY',
}
export {
    RestaurantStatusEnum
}
